// A park code from an invite link: wahala.io/p/{CODE} redirects to the game with ?park={CODE}.
// Read once at boot and taken out of the address bar, so a reload or a shared screenshot of the
// URL never joins again. Inside the Lagos Life frame the game always loads its root: no code.
import { CODE_RE_CLIENT } from './code';

let invited: string | null = null;

/** Called once at boot: keep a valid ?park= code for after sign-in and drop it from the URL. */
export function takeInvite(): void {
  const q = new URLSearchParams(location.search);
  if (!q.has('park')) return;
  const code = (q.get('park') ?? '').toUpperCase();
  q.delete('park');
  const rest = q.toString();
  history.replaceState(history.state, '', `${location.pathname}${rest ? `?${rest}` : ''}${location.hash}`);
  invited = CODE_RE_CLIENT.test(code) ? code : null;
}

/** The invited park's code, once: the first caller gets it, every later one gets null. */
export function claimInvite(): string | null {
  const code = invited;
  invited = null;
  return code;
}
